module.exports = __webpack_public_path__ + "static/media/4_Beneficiarios.fe046cc9.mp3";